<template>
  <el-dialog
    :visible.sync="centerDialogVisible"
    :close-on-click-modal="false"
    :show-close="false"
    center>
    <img src="@/assets/image/close.png" @click="resetForm('ruleForm')" />
    <h2>新增使用者</h2>
    <div class="roomBody">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="auto" class="demo-ruleForm">
        <el-form-item label="姓名" prop="name">
          <el-input v-model="ruleForm.name"></el-input>
        </el-form-item>
        <el-form-item label="職稱" prop="job">
          <el-input v-model="ruleForm.job"></el-input>
        </el-form-item>
        <el-form-item label="帳號" prop="account">
          <el-input v-model="ruleForm.account"></el-input>
        </el-form-item>
        <el-form-item label="密碼" prop="password">
          <el-input v-model="ruleForm.password" :placeholder="isshow?'請輸入至少 8 個字元':'留空則不修改密碼'" show-password></el-input>
        </el-form-item>
        <el-form-item v-if="isshow" label="確認密碼" prop="passwordTwo">
          <el-input v-model="ruleForm.passwordTwo" placeholder="請再輸入一次" show-password></el-input>
        </el-form-item>
        <el-form-item label="系統權限" prop="role_ids">
          <el-select v-model="ruleForm.role_ids" placeholder="請選擇系統權限" multiple>
            <el-option v-for="(item,i) in roleList" :key="i" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
     <div @click="resetForm('ruleForm')">取消填寫</div>
      <div @click="submitForm('ruleForm')">確認儲存</div>
  </span>
  </el-dialog>
</template>

<script>
import { createUser, updateUser } from "@/api";

export default {
  name: "roomDig.vue",
  props: {
    roleList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    let validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("請再次輸入密碼"));
      } else if (value !== this.ruleForm.password) {
        callback(new Error("兩次輸入密碼不一致!"));
      } else {
        callback();
      }
    };
    return {
      isshow: true,
      centerDialogVisible: false,
      ruleForm: {
        name: "",
        job: "",
        account: "",
        password: "",
        passwordTwo: "",
        role_ids: []
      },
      rules: {
        name: [
          { required: true, message: "請輸入姓名", trigger: "blur" }
        ],
        job: [
          { required: true, message: "請輸入職稱", trigger: "blur" }

        ],
        account: [
          { required: true, message: "請輸入帳號", trigger: "blur" }
        ],
        password: [
          { required: this.isshow, message: "請輸入密碼", trigger: "blur" },
          { min: 8, message: "長度最少是8位", trigger: "blur" }
        ],
        passwordTwo: [
          { required: true, validator: validatePass2, trigger: "blur" }
        ],
        role_ids: [
          { required: true, message: "請選擇權限", trigger: "change" }
        ]
      }
    };
  },
  methods: {
    init(row) {
      if (row) {
        this.isshow = false
        this.ruleForm = row;
        this.$set(this.ruleForm,'password','')
        this.$set(this.ruleForm,'role_ids',row.roles)
      } else {
        this.isshow = true
        this.ruleForm = {
          name: "",
          job: "",
          account: "",
          password: "",
          passwordTwo: "",
          role_ids: []
        }
      }
      this.centerDialogVisible = true;
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if(this.isshow){
            createUser(this.ruleForm).then(res => {
              if(res.code == 200) {
                this.$message.success("創建成功");
                this.$emit("done");
                this.centerDialogVisible = false;
              }
            });
          }else{
            updateUser(this.ruleForm).then(res => {
              if(res.code == 200) {
                this.$message.success("編輯成功");
                this.$emit("done");
                this.centerDialogVisible = false;
              }
            });
          }

        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.centerDialogVisible = false;
    }
  }
};
</script>


<style scoped lang="scss">
::v-deep .el-dialog {
  width: 650px;
  border-radius: 15px;
  padding: 0;
  position: relative;
}

img {
  width: 30px;
  height: 30px;
  object-fit: contain;
  position: absolute;
  right: -40px;
  top: 10px;
  cursor: pointer;
}

::v-deep .el-dialog__footer {
  padding: 0;

  .dialog-footer {
    display: flex;
    align-items: center;

    div {
      flex: 1;
      background: #DBBD80;
      color: #FFFFFF;
      font-size: 20px;
      padding: 15px 20px;
      cursor: pointer;
      font-weight: bolder;
    }

    div:first-child {
      border-radius: 0 0 0 15px;
      border-right: 1px solid #FFFFFF;
    }

    div:last-child {
      border-radius: 0 0 15px 0px;
    }
  }

}

h2 {
  font-size: 30px;
  font-weight: bolder !important;
  text-align: center;
  margin: 0;
  color: #DBBD80;
  padding-bottom: 20px;
  border-bottom: 1px solid #DBBD80;
  margin-bottom: 20px;
}

.roomBody {
  ::v-deep .el-form-item__label-wrap .el-form-item__label {
    font-size: 16px;
  }

  ::v-deep .el-form-item__content {
    margin-left: 100px;
  }

  ::v-deep .el-form-item__error {
    font-size: 14px;
  }

  ::v-deep .el-input__inner {
    border: none;
    border-bottom: 1px solid #b6b8bd;
    border-radius: 0;

  }

  .el-select {
    width: 100%;
  }

}
</style>
